import React from 'react'

const EmbedComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default EmbedComponent
